import apiClient from './ApiInterceptor';

export const fetchClassTypes = async (ids) => {
    try {
        const params = {
            ids: ids
        };
        const response = await apiClient.get('/class_types', { params });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('ClassTypeApi - fetchClassTypes, Error fetching data:', error);
        return { success: false, error };
    }
};
